import { AddLayerPanel } from './AddLayerPanel';
import { EditLayerVersionPanel } from './EditLayerVersionPanel';
import { ReviewQueuePanel } from './ReviewQueuePanel';
import {
  LayerSidebarPanelProvider,
  useLayerSidebarPanel,
} from './LayerSidebarPanel';
import { useUscgMapContext } from './UscgMapContext';
import { ViewLayersPanel } from './ViewLayersPanel';
import { DraftNewVersionPanel } from './DraftNewVersionPanel';
import { registerArcGisOAuthInfo } from './arcgis-integration/arcGisPortal';
import { useCurrentGroup } from 'components/IAP/hooks/commonHooks';

function LayersViewContent() {
  const { activePanel, setActivePanel } = useLayerSidebarPanel();
  const { setSidebarSelectedInternalLayer } = useUscgMapContext();
  const group = useCurrentGroup();

  if (activePanel === 'add_external_layer') {
    return (
      <AddLayerPanel onBack={() => setActivePanel(null)} layerType="external" />
    );
  }
  if (activePanel === 'add_internal_layer') {
    return (
      <AddLayerPanel onBack={() => setActivePanel(null)} layerType="internal" />
    );
  }
  if (activePanel === 'add_dhs_layer') {
    return (
      <AddLayerPanel onBack={() => setActivePanel(null)} layerType="dhs" />
    );
  }

  if (activePanel === 'review_queue') {
    return <ReviewQueuePanel onBack={() => setActivePanel(null)} />;
  }

  if (activePanel === 'edit_layer_version') {
    return (
      <EditLayerVersionPanel
        onBack={() => {
          setActivePanel(null);
          setSidebarSelectedInternalLayer(null);
        }}
      />
    );
  }

  if (activePanel === 'draft_new_version') {
    return (
      <DraftNewVersionPanel
        onBack={() => {
          setActivePanel(null);
          setSidebarSelectedInternalLayer(null);
        }}
      />
    );
  }

  return (
    <ViewLayersPanel
      onAddLayer={async (layerType) => {
        if (layerType === 'external') {
          await registerArcGisOAuthInfo(group);
          setActivePanel('add_external_layer');
        } else if (layerType === 'dhs') {
          setActivePanel('add_dhs_layer');
        } else {
          setActivePanel('add_internal_layer');
        }
      }}
      onOpenReviewQueue={() => setActivePanel('review_queue')}
    />
  );
}

export const LayersView = () => {
  return (
    <div className="h-100">
      <LayerSidebarPanelProvider>
        <LayersViewContent />
      </LayerSidebarPanelProvider>
    </div>
  );
};
